import Swal from 'sweetalert2';

export function CustomSwal(options) {
    const defaultOptions = {
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d2d1d2',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        reverseButtons: true,
        focusConfirm: true,
        allowEnterKey: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-black'
        },
        buttonsStyling: false
    };
    const merged = Object.assign(defaultOptions, options);

    return Swal.fire(merged);
}

export function checkFiscalCode(cf) {
    if ( ! /^[0-9A-Z]{16}$/.test(cf) ) {
        return false;
    }

    let s = 0;
    const even_map = "BAFHJNPRTVCESULDGIMOQKWZYX";

    for (let i = 0; i < 15; i++) {
        const c = cf[i];
        let n = 0;

        if ("0" <= c && c <= "9") {
            n = c.charCodeAt(0) - "0".charCodeAt(0);
        } else {
            n = c.charCodeAt(0) - "A".charCodeAt(0);
        }

        if ( (i & 1) === 0) {
            n = even_map.charCodeAt(n) - "A".charCodeAt(0);
        }

        s += n;
    }

    return s % 26 + "A".charCodeAt(0) === cf.charCodeAt(15);
}

export function getSediRitiro(response, sortArray = ['K','L','H','P','B','E','G','T','Z','S']) {
    let res = response.map(r => {
        r.splits = r.indirizzo.split(/, (\d{5}) /i);
        switch(r.id_sede) {
            case 'G':
                r.nome_sede = "Calcinato";
                break;
            case 'E':
                r.nome_sede = "Busto Arsizio";
                break;
            case 'P':
                r.nome_sede = "San Martino Dall'argine";
                break;
        }
        const splits = r.indirizzo.split(', ', 2);
        r.via = splits[0] || '';
        const prov = splits[1].match(/\(([^)]+)\)/);
        r.provincia = prov && prov.length > 1 ? prov[1] : '';
        return r;
    });
    console.log('cimone2', res);
    res = res.filter(r => !['R', 'A', 'J'].includes(r.id_sede)); // tolgo autore
    // res.sort((a, b) => sortArray.indexOf(a.id_sede) - sortArray.indexOf(b.id_sede));
    res.sort((a, b) => a.nome_sede.localeCompare(b.nome_sede));
    return res;
}

export function setTooltipInfoSede(info, locale) {
    const data = JSON.parse(info).hours;
    const chiuso = { it: "Chiuso",  en: "Closed",  de: "Geschlossen" };
    const chiusoLingua = chiuso[locale];
    const giorniSettimana = {
        it: ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"],
        en: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        de: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"]
    };
    const giorniLingua = giorniSettimana[locale];
    const indexOggi = data.findIndex(g => g.day === giorniLingua[new Date().getDay()]) - 1;

    let html = `<table border="1" cellpadding="6" cellspacing="0" style="border-collapse: collapse; width: 100%; max-width: 400px; font-family: sans-serif; font-size: 14px; text-align: left;">
                    <thead>
                      <tr>
                        <th>Giorno</th>
                        <th>Orari</th>
                      </tr>
                    </thead>
                    <tbody>`;
    data.forEach((item, idx) => {
        const style = idx === indexOggi ? "color: #c71a20; font-weight: bold;" : "";
        const orario = item.open === "Chiuso" ? chiusoLingua : item.open;
        html += `<tr style="${style}">
                    <td style="font-weight: bold;">${giorniLingua[idx]}</td>
                    <td>${orario}</td>
                  </tr>`;
    });
    return html += `</tbody></table>`;
}

export function isMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}
